import React, { useState, useRef, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { bridgeURI } from '../config'
import { ChainMapping } from '../config'

const _Bridge = styled.button`
  display:flex;
  font-family: Montserrat;
  background-color: ${({ theme }) => theme.bridgeBackgroundColor};

  border-radius: 2.4rem;
  padding: 0.7rem 1.4rem 0.7rem 1.4rem;
  font-size: 1.75rem;
  text-align: center;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.bridgeBorderColor};
  
  :hover {
    border: 1px solid ${({ theme }) => theme.bridgeBorderColorHover};
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.15rem;
  }
`

const _Link = styled.a`
  display:flex;
  text-decoration: none;
  color: ${({ theme }) => theme.bridgeColor};
  justify-content: center;
  vertical-align:center;
`

interface Props {
  appChain: ChainMapping
}

function Bridge({ appChain }: Props) {
  return (
    <_Bridge>
      <_Link  href={bridgeURI} target='_blank'>
      <span><span style={{fontFamily:'Montserrat'}}>Bridge to </span><span style={{fontFamily:'Montserrat'}}>{appChain!.config.chain == 'Mainnet' ? `${appChain!.config.network}` : `${appChain.config!.network} ${appChain.config!.chain}`}</span></span>
      <sup style={{fontFamily:'Montserrat'}}>↗</sup>
      </_Link>
    </_Bridge>    
  )
}

export default Bridge
